import  ApiService  from '../../services/api.service'
import { TokenService } from '../../services/storage.service';
import HashMake from '../../services/hash.service';

const state =  {
    loading: false,
    isShow: false,
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
    appointmentLoading:false,
    unavailableLoading: false,
    unavailableSlots:[],
    unavailableDays: [],
    holidays: [],
    appointmentCached: null
}
const getters = {
    loading: state => state.loading,
    response: (state) => state.response,
    isShow: (state) => state.isShow,
    appointmentLoading: (state) => state.appointmentLoading,
    appointmentDetails: (state) => state.appointmentDetails,
    unavailableLoading: (state) => state.unavailableLoading,
    unavailableSlots: (state) => state.unavailableSlots,
    unavailableDays: (state) => state.unavailableDays,
    holidays: (state) => state.holidays,
    appointmentCached: (state) => state.appointmentCached
}
const mutations = {
    setLoading(state, value) {
        state.loading = value;
    },
    setAppointmentDetails(state, value){
        state.appointmentDetails = value;
    },
    setAppointmentLoading(state, value) {
        state.appointmentLoading = value;
    },
    setError(state, data) {
        state.isShow = true;
        state.response.variant = 'danger';
        state.response.message = data.msg;
        state.response.errmsg = data.errors;
    },
    resetState(state) {
        state.isShow = false;
        state.response.variant = '';
        state.response.message = '';
        state.response.errmsg = [];
    },
    setUnavailableLoading(state, value) {
        state.unavailableLoading = value
    },
    setUnavailableSlots(state, value) {
        state.unavailableSlots = value
    },
    setUnavailableDays(state, value) {
        state.unavailableDays = value
    },
    setHolidays(state, value) {
        state.holidays = value
    },
    setAppointmentCached(state, value) {
        state.appointmentCached = value
    }
}
const actions = {
    resetError({commit}) {
        commit('resetState')
    },
    showError({commit}, value) {
        commit('setError', value)
    },
    async addAppointment({commit}, appointmentDet) {
        let token = TokenService.getToken();
        commit('setAppointmentLoading', true)
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.post('/customer/appointment/create', appointmentDet)
                .then(data => {
                    commit('setAppointmentDetails', data)
                    resolve(data)
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setAppointmentLoading', false);
                })
            })
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            return new Promise((resolve, reject) => {
                ApiService.post('/anonymous/appointment/create?anonymous_id='+anonymousId, appointmentDet)
                .then(response => {
                    resolve(response)
                }).catch((e) => {
                    reject()
                }).finally(() => {
                    commit('setAppointmentLoading', false);
                })
            })
        }
    },
    getUnavailableSlotList({commit}, dealerId) {
        commit('setUnavailableLoading', true)
        return new Promise((resolve, reject) => {
            ApiService.get('/dealer/'+dealerId+'/appointments')
            .then(response => {
                let responseData = HashMake.decrypt(response.data.data)
                commit('setUnavailableSlots', responseData);  
                
                let unavailableDays = []

                $.each(responseData,function(key,value){
                    if(value.full_day && _.indexOf(unavailableDays,value.schedule_date) === -1){
                        unavailableDays.push(value.schedule_date)
                    }
                })

                commit('setUnavailableDays',unavailableDays);
                resolve(responseData)
            }).catch((e) => {
                reject()
            }).finally(() => {
                commit('setUnavailableLoading', false);
            })
        })
    },
    getHolidayList({commit}, dealerId) {
        commit('setUnavailableLoading', true)
        return new Promise((resolve, reject) => {
            ApiService.get('get-holidays')
                .then(response => {
                let result = [];
                if (response.data !== []) {
                    result = response.data.map((item) => item.start_date);
                }
                commit('setHolidays',result);
                resolve(response)
            }).catch((e) => {
                reject()
            })
        })
    },
    async getAppointmentCached({commit}, dealerId) {
        let token = TokenService.getToken();
        commit('setAppointmentLoading', true)
        if(token) {
            return new Promise((resolve, reject) => {
                ApiService.get('customer/appointment/get-appointment-cached')
                .then(response => {
                    commit('setAppointmentCached',response.data);
                    resolve(response)
                }).catch((e) => {
                    reject(e)
                }).finally(() => {
                    commit('setAppointmentLoading', false);
                })
            })
        } else {
            let anonymousId = ''
            if(TokenService.getGuestToken()) {
                anonymousId = TokenService.getGuestToken()
            } else {
                TokenService.setGuestToken()
                anonymousId = TokenService.getGuestToken()
            }
            return new Promise((resolve, reject) => {
                ApiService.get('/anonymous/appointment/get-appointment-cached?anonymous_id='+anonymousId)
                .then(response => {
                    commit('setAppointmentCached', response.data);
                    resolve(response)
                }).catch((e) => {
                    reject(e)
                }).finally(() => {
                    commit('setAppointmentLoading', false);
                })
            })
        }
    },
    setAppointmentCached({commit}, data) {
        commit("setAppointmentCached", data)
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}